<template>
  <div id="android-redirect"></div>
</template>

<script>
export default {
  name: "android-redirect",
  mounted() {
    window.location.href =
      "https://play.google.com/store/apps/details?id=cz.tmesolutions.easiscore&hl=cs&gl=US";
  }
};
</script>
